import withMainLayout from "components/create-main-layout"
import LandingFragment from "components/fragments/landing-fragment"
import PageName from "constants/pageName"
import SourceKeys from "constants/sourceKeys"
import React, { useCallback, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { actionTypes, makeAction } from "states/actions"
import appendScript from "utils/appendScript"

import Config from "utils/publicRuntimeConfig"

import { Source } from "utils/selector"
import { useScope } from "utils/sentryUtils"
import useBeforeUnload from "utils/useBeforeUnload"
import { isNotEmptyString } from "utils/validate"

const LandingPage = () => {
  const linkSource = useSelector(Source)
  const dispatch = useDispatch()
  useBeforeUnload()

  const checkSSO = useCallback(async () => {
    const isNotPrivateLink = linkSource && linkSource !== SourceKeys.marketing && linkSource !== SourceKeys.directsales && linkSource !== SourceKeys.agentsales
    if (isNotPrivateLink) {
      const ssoClient = await sso.createSSOClient({ redirect_url: null })
      let token = await ssoClient.getAccessToken()
      if (token && isNotEmptyString(token)) {
        dispatch(makeAction(actionTypes.APP_CHECK_SSO, { token }))
      }
    }
  }, [linkSource])

  useScope(PageName.landing)

  useEffect(() => {
    appendScript({
      targetElement: document.body,
      async: true,
      src: Config.ssoScriptUrl,
      id: "sso-script",
      onScriptLoad: checkSSO
    })
    return () => {
    }
  }, [])
  return <LandingFragment />
}

LandingPage.displayName = PageName.landing

export default withMainLayout(LandingPage)
